import {
  Element,
  InstallSpec,
  ItemComponent,
  Option,
} from "@p0security/shared/install/types";

export const SplunkStackComponents = InstallSpec({
  settings: ItemComponent({
    type: "singleton",
    label: "Integration settings",
    description: "Global settings for the Splunk Stack integration",
    maturity: "ga",
    hidden: true,
    schema: {
      cacheTtlMs: Element({
        label: "Cache TTL (ms)",
        description: "Time-to-live for cached Splunk Stack node data",
        type: "string",
        optional: true,
        hidden: true,
      }),
    },
  }),
  base: ItemComponent({
    label: "Splunk Stack",
    type: "generated",
    hidden: true,
    maturity: "ga",
    schema: {},
  }),
  "iam-write": ItemComponent({
    label: "IAM management",
    description:
      "Allows P0 to manage access to your Splunk Stack UI for your users via manifest-driven configuration.",
    type: "string",
    maxItems: 1,
    maturity: "ga",
    schema: {
      service: Element({
        label: "Service provider",
        description:
          "The service provider hosting the external function to call",
        type: "select",
        default: "aws",
        options: {
          aws: Option({
            maturity: "ga" as const,
            key: "aws",
            label: "AWS",
            schema: {
              lambda: Element({
                label: "Function caller",
                description:
                  "Select the AWS Lambda function to invoke for this integration",
                type: "dynamic",
              }),
            },
          }),
          // Future: Add Azure, GCP support
          azure: Option({
            maturity: "preview" as const,
            key: "azure",
            label: "Azure",
            schema: {
              service: Element({
                label: "Function caller",
                description:
                  "Select the Azure Function to invoke for this integration",
                type: "dynamic",
              }),
            },
          }),
          gcp: Option({
            maturity: "preview" as const,
            key: "gcp",
            label: "GCP",
            schema: {
              cloudRun: Element({
                label: "Function caller",
                description:
                  "Select the GCP Cloud Run service to invoke for this integration",
                type: "dynamic",
              }),
            },
          }),
        },
      }),
    },
  }),
});
